import * as React from 'react';
import styled from 'styled-components';

import Starfield, {
  StarfieldVariantProp,
} from 'components/Starfield/Starfield';
import { PAGE_REGIONS, getPageRegionProps } from 'utils';
import { color } from 'styles/utils';

const HeroSection = styled(({ children, variant, ...props }) => (
  <section {...getPageRegionProps(PAGE_REGIONS.hero)} {...props}>
    <Starfield variant={variant} />
    {children}
  </section>
))`
  background-color: ${color('darkestTeal')};
  color: ${color('white')};
  overflow: hidden;
  padding: 4.5rem 1.5rem;
  position: relative;

  main > & {
    padding-top: calc(var(--sleuth-safe-area-inset-top, 0) + 4.5rem);
  }
`;

HeroSection.propTypes = {
  variant: StarfieldVariantProp,
};

HeroSection.defaultProps = {
  variant: 'secondary',
};

export default HeroSection;
